import { WebGLRenderer } from 'three';
import { usesMobileRendering } from './mobileRendering';

// Keep the same scene and quality settings while avoiding the WebGL 2 driver
// path on Apple touch devices. Three r161 supports both versions.
export const createCoreboundRenderer = (options = {}) => {
  const requested =
    typeof window === 'undefined'
      ? null
      : new URLSearchParams(window.location.search).get('coreboundWebGL');
  const preferWebGL1 =
    requested === '1' || (requested !== '2' && usesMobileRendering());
  if (!preferWebGL1 || options.context) return new WebGLRenderer(options);
  const canvas = options.canvas || document.createElement('canvas');
  const attributes = {
    alpha: options.alpha ?? false,
    antialias: options.antialias ?? true,
    depth: options.depth ?? true,
    stencil: options.stencil ?? true,
    premultipliedAlpha: options.premultipliedAlpha ?? true,
    preserveDrawingBuffer: options.preserveDrawingBuffer ?? false,
    powerPreference: options.powerPreference || 'default',
    failIfMajorPerformanceCaveat: options.failIfMajorPerformanceCaveat ?? false,
  };
  const context =
    canvas.getContext('webgl', attributes) ||
    canvas.getContext('experimental-webgl', attributes) ||
    canvas.getContext('webgl2', attributes);
  if (!context) throw new Error('WebGL unavailable');
  return new WebGLRenderer({ ...options, canvas, context });
};
